import React from "react";
import "./MarsMart.css";

export default function MMFloatingCart({ itemCount = 0, onClick }) {
  if (itemCount <= 0) return null;

  return (
    <button
      type="button"
      className="mm-floating-cart-btn"
      onClick={onClick}
      aria-label={`Open cart with ${itemCount} items`}
    >
      <span className="mm-floating-cart-icon" aria-hidden="true">
        MM
      </span>
      <span className="mm-floating-cart-text">Cart</span>
      <span className="mm-floating-cart-count">{itemCount}</span>
    </button>
  );
}
